// frontend/src/components/Charts/LineChart.jsx

import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

function LineChart({ data, title }) {
  // Preparar datos para la gráfica
  const chartData = {
    labels: data.map(d => d.day), // Días del mes (1, 2, 3, ...)
    datasets: [
      {
        label: 'Propuestas Enviadas',
        data: data.map(d => d.quotes_sent),
        borderColor: 'rgb(5, 205, 153)', // Verde MAS+
        backgroundColor: 'rgba(5, 205, 153, 0.1)',
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: 'rgb(5, 205, 153)',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
      },
      {
        label: 'Propuestas Aceptadas',
        data: data.map(d => d.quotes_accepted),
        borderColor: 'rgb(45, 206, 137)', // Verde claro
        backgroundColor: 'rgba(45, 206, 137, 0.1)',
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: 'rgb(45, 206, 137)',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
      },
      {
        label: 'Órdenes Recibidas',
        data: data.map(d => d.orders_received),
        borderColor: 'rgb(251, 99, 64)', // Naranja
        backgroundColor: 'rgba(251, 99, 64, 0.1)',
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: 'rgb(251, 99, 64)',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
            family: "'Open Sans', sans-serif",
          },
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        padding: 12,
        displayColors: true,
        callbacks: {
          title: function(context) {
            return context[0].label;
          },
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            label += context.parsed.y;
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: '#8898aa',
          font: {
            size: 11,
          },
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 15,
        },
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
          drawBorder: false,
        },
        ticks: {
          color: '#8898aa',
          font: {
            size: 11,
          },
          beginAtZero: true,
          precision: 0,
        },
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false,
    },
  };

  return (
    <div style={{ height: '300px', position: 'relative' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default LineChart;
